import {PIXI} from '@colonist/pixi'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {CardEnum, TurnState} from '@colonist/game-states'

import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export interface UIGameActionConfirmationParameters {
    texture: PIXI.Texture
    canTakeAction: boolean
    action: (index: number) => void
    resourcesToBuild: CardEnum[]
    bankActionAmount?: number | undefined
}

export abstract class UIHoverActionController implements UIGameMechanic {
    private _validLocations: number[] = []
    private canTakeAction: boolean = false

    protected readonly uiGameManager: UIGameManager
    protected readonly player: PlayerValidator
    protected readonly texture: PIXI.Texture

    protected resources: CardEnum[] = []
    protected shouldHideOnSpecialBuildPhase: boolean = false
    protected useResources: boolean = true

    protected action: (index: number) => void
    isCornerAction: boolean = false
    isShipAction: boolean = false

    protected abstract updateState(): void
    protected abstract getTexture(index: number): PIXI.Texture
    protected abstract getBankActionAmount(index: number): number | undefined

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager

        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated:
            case UIGameEventEnums.DiceStateUpdated:
            case UIGameEventEnums.FinishedBuildingGame:
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateState(); break
            default: break
        }
    }

    getConfirmationParameters(index: number): UIGameActionConfirmationParameters {
        return {
            texture: this.getTexture(index),
            canTakeAction: this.canTakeAction,
            action: () => {
                this.action(index)
            },
            resourcesToBuild: this.getResourcesToBuild(),
            bankActionAmount: this.getBankActionAmount(index),
        }
    }

    updateHoverLocations(validLocations: number[] | undefined, canTakeAction: boolean): void {
        const filteredValidLocations = this.filterValidLocationsForClient(validLocations, canTakeAction)
        this.validLocations = filteredValidLocations ?? []
        this.canTakeAction = canTakeAction
    }

    getResourcesToBuild(): CardEnum[] {
        return this.resources
    }

    get validLocations(): number[] {
        const isCurrentTurnSpecialBuildPhase = this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase
        if(this.shouldHideOnSpecialBuildPhase && isCurrentTurnSpecialBuildPhase) {
            return []
        }

        return this._validLocations
    }

    set validLocations(value: number[]) {
        this._validLocations = value
    }

    // eslint-disable-next-line class-methods-use-this
    private filterValidLocationsForClient(locations: number[] | undefined, canTakeAction: boolean): number[] | undefined {
        if(!UIUtilsEjsVariables.isUserOnMobileApp) return locations
        if(canTakeAction) return locations
        return []
    }
}
